import React from 'react'
import GreenBar from '../GreenBar'

import '../../css/general.css'
import SideBar from '../SideBar'
import Container from 'react-bootstrap/Container'
import Row from 'react-bootstrap/Row'
import Col from 'react-bootstrap/Col'
import insta1 from '../../Assets/images/Insta1.jpg'
import insta2 from '../../Assets/images/Insta2.jpg'
import insta3 from '../../Assets/images/Insta3.jpg'
import insta4 from '../../Assets/images/Insta4.jpg'
import insta5 from '../../Assets/images/Insta5.jpg'
import insta6 from '../../Assets/images/Insta6.jpg'
import insta7 from '../../Assets/images/Insta7.jpg'
import insta8 from '../../Assets/images/Insta8.jpg'
import insta9 from '../../Assets/images/Insta9.jpg'
import insta10 from '../../Assets/images/Insta10.jpg'
import insta11 from '../../Assets/images/Insta11.jpg'
import insta12 from '../../Assets/images/Insta12.jpg'


export default function FindRetailer() {
    return (
        <Container>
            <Row>
            <Col lg={{span: 9}} md={{ span: 12 }} className='col-left'>
                    <h1>WHERE TO BUY!</h1>
                    <hr />
                    <p>Want to know if there is a retailer nearby? Zoom in to your town and check it out!</p>
                    
                    <iframe src="https://www.google.com/maps/d/u/0/embed?mid=1NO5N6pIVCqxPOW1gAXnTC2_pAvi48wNQ&ehbc=2E312F" width="640" height="480"></iframe>
                    <hr />
                    <h3>We’d love you to follow us on Instagram! <a href='https://www.instagram.com/clingonaustralia/' target="_blank" style={{color: '#5bccbf'}}>#clingonaustralia</a></h3>
                    <p>Make sure you tag us, so we can see your projects painted with one of our brushes! <br />We love to share our customers work!</p>
                    <hr />
                    <Row>
                        <Col>
                        <img src={insta1} className='instagramPosts'/>
                        <img src={insta2} className='instagramPosts'/>
                        <img src={insta3} className='instagramPosts'/>
                        </Col>
                    </Row>
                    <Row>
                        <Col>
                        <img src={insta4} className='instagramPosts'/>
                        <img src={insta5} className='instagramPosts'/>
                        <img src={insta6} className='instagramPosts'/>
                        
                        </Col>
                    </Row>
                    <Row>
                        <Col>
                        <img src={insta7} className='instagramPosts'/>
                        <img src={insta8} className='instagramPosts'/>
                        <img src={insta9} className='instagramPosts'/>
                        </Col>
                    </Row>
                    <Row>
                        <Col>
                        <img src={insta10} className='instagramPosts'/>
                        <img src={insta11} className='instagramPosts'/>
                        <img src={insta12} className='instagramPosts'/>
                        </Col>
                    </Row>
                </Col>
                <Col lg={{ span: 3}} className="col-right">
                    <SideBar />
                    <GreenBar />
                    </Col>

            </Row>
        </Container>
    )
}